<template>

    <Toast/>

    <MenuSiLogin/>

    <div class="px-6 surface-overlay relative">

        <div class="border-2 surface-border border-round surface-section flex-auto">

            <div v-show="activeTab === 1" class="w-full lg:w-12 p-4 lg:p-7 surface-card">
                <div class="col-12 md:col-12">
                    <div class="card p-fluid">

                        <div class="text-900 text-2xl font-medium mb-6">Login</div>

                        <div class="field">
                            <label for="username" class="block text-900 font-medium mb-2">Username</label>
                            <InputText id="username" type="text" v-model="userData.username" placeholder="Username"
                                       class="w-full mb-4"/>
                        </div>

                        <div class="field">
                            <label for="password" class="block text-900 font-medium mb-2">Password</label>

                            <InputText id="password"
                                       :type="showPassword ? 'text' : 'password'"
                                       v-model="userData.password"
                                       placeholder="Password"
                                       class="w-full pr-10 mb-4"/>
                        </div>

                        <div class="flex align-items-center justify-content-between mb-6">
                            <div class="flex align-items-center">
                                <Checkbox id="showPasswordToggle" :binary="true" v-model="showPassword"
                                          class="mr-2"></Checkbox>
                                <label for="showPasswordToggle">Show Password</label>
                            </div>
                            <div class="flex align-items-center">
                                <Checkbox id="rememberme" :binary="true" v-model="rememberme"
                                          class="mr-2"></Checkbox>
                                <label for="rememberme">Remember me</label>
                            </div>
                            <a class="font-medium no-underline ml-2 text-teal-500 text-right cursor-pointer"
                               @click="handleForgotPassword">
                                Forgot password?
                            </a>
                        </div>

                        <div class="flex align-items-center align-content-center justify-content-between mb-6">
                              <span>
                                  By proceeding, you agree to the
                                <a href='https://simplyinvesting.com/terms' target='_blank'>Terms of Use</a>
                                , <a href='https://simplyinvesting.com/disclaimer' target='_blank'>Disclaimer</a>
                                , and <a href='https://simplyinvesting.com/privacy' target='_blank'>Privacy Policy</a>
                              </span>
                        </div>

                        <Button label="Login" icon="pi pi-user" class="w-full" :loading="submitted"
                                @click="handleLogin"></Button>

                        <div class="mt-6 text-center text-600">
                            Don't have an account?
                            <a class="font-medium no-underline ml-2 text-teal-500 text-right cursor-pointer"
                               @click="handleRegister">Sign Up</a>
                        </div>
                    </div>

                </div>
            </div>


            <div v-show="activeTab === 2" class="w-full lg:w-12 p-4 lg:p-7 surface-card">
                <div class="col-12 md:col-12">
                    <div class="card p-fluid">

                        <div class="text-900 text-2xl font-medium mb-6">Login</div>

                        <div class="field">
                            <p class="text-600 line-height-3 mt-0 mb-4">
                                A One-Time Pin (OTP) has been emailed to you at {{ maskedEmail }}.
                                <br><br>
                                Didn't receive your OTP after 5 minutes? Please check your spam or junk folder first.
                                If it's not there, you can temporarily regain access by clicking on "Forgot Password?" below to reset your password.
                                <br><br>
                                If you don't have access to your email or aren't receiving our emails, please contact
                                info@simplyinvesting.com for help.
                            </p>
                        </div>

                        <div class="field">
                            <label for="activationCode" class="block text-900 font-medium mb-2">Email OTP (begins with
                                {{ otpHint }})</label>
                            <InputText id="activationCode" type="text" v-model="userData.activationCode"
                                       placeholder="Enter the 6-digit OTP sent via email"
                                       class="w-full mb-4"/>
                        </div>

                        <div class="flex align-items-center align-content-center justify-content-between mb-6">
                              <span>
                                  By proceeding, you agree to the
                                <a href='https://simplyinvesting.com/terms' target='_blank'>Terms of Use</a>
                                , <a href='https://simplyinvesting.com/disclaimer' target='_blank'>Disclaimer</a>
                                , and <a href='https://simplyinvesting.com/privacy' target='_blank'>Privacy Policy</a>
                              </span>
                        </div>

                        <Button label="Login" icon="pi pi-user" class="w-full" :loading="submitted"
                                @click="handleVerifyTfa"></Button>

                        <div class="mt-6 text-center text-600">
                            <a class="font-medium no-underline ml-2 text-teal-500 text-right cursor-pointer"
                               @click="handleCancel">Back to Login?</a>
                        </div>

                        <div class="mt-6 text-center text-600">
                            <a class="font-medium no-underline ml-2 text-teal-500 text-right cursor-pointer"
                               @click="handleForgotPassword">Forgot password?</a>
                        </div>
                    </div>

                </div>
            </div>

        </div>

    </div>

    <SiFooter/>

</template>

<script>
import MenuSiLogin from "@/components/menu/simodule/MenuSiLogin.vue";
import UserService from "@/service/UserService";
import {useUserStore} from "@/stores/UserStore";
import AuthenticationService from "@/service/AuthenticationService";
import CompanyService from "@/service/CompanyService";
import DashboardService from "@/service/DashboardService";
import AuditTrailService from "@/service/AuditTrailService";
import ProductService from "@/service/ProductService";
import PractitionerService from "@/service/PractitionerService";
import LocationService from "@/service/LocationService";
import BillingPlanService from "@/service/BillingPlanService";
import SupplierService from "@/service/SupplierService";
import ClientService from "@/service/ClientService";
import SiFooter from "@/components/heading/authentication/SiFooter.vue";

export default {
    components: {
        SiFooter,
        MenuSiLogin
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        document.title = "Simply Investing"; // Update the browser tab title
        this.setFavicon("images/blocks/logos/favicon.simplyinvesting.96x96.png");

        try {
            const userPingResponse = await UserService.getUserPing();
            console.log("[Login][mounted] System is active.");
            console.log("[Login][mounted] Data = ", userPingResponse);
        } catch (e) {
            console.log("[Login][mounted] System is NOT active.");
            console.log("[Login][mounted] Error = ", e);
            this.userStore.clearUser();
            // this.$router.push("login");
            this.$router.replace('/siLogin');
            return;
        }

        if (!this.userStore.user.id) {
            console.log("[Login][mounted] User is NOT defined.");
            this.userStore.clearUser();
            // this.$router.push("login");
            this.$router.replace('/siLogin');
            return;
        }

        this.activeTab = 1;
        this.userData = {};
        this.userData.username = '';
        this.userData.password = '';
        this.userData.activationCode = '';
        this.submitted = false;
    },
    data() {
        return {
            activeTab: 1,
            userData: {},
            userConfiguration: {},
            profile: {},
            submitted: false,
            rememberme: false,
            showPassword: false,
            tfaRequired: false,
            maskedEmail: null,
            otpHint: null,
            deliveryHint: null,
        }
    },
    methods: {
        setFavicon(url) {
            // Check if a <link rel="icon"> tag already exists
            let faviconLink = document.querySelector("link[rel='icon']");

            if (!faviconLink) {
                // Create a new <link> element if one doesn't exist
                faviconLink = document.createElement("link");
                faviconLink.rel = "icon";
                document.head.appendChild(faviconLink);
            }

            // Update the favicon URL
            faviconLink.href = url;
        },
        handleResult(index, result) {
            // console.log("[Login][handleResult] index = ", index);
            // console.log("[Login][handleResult] result = ", result);

            switch (index) {
                case 0:
                    this.userStore.setCompanyConfiguration(result.data);
                    break;
                case 1:
                    this.userStore.setFinancialSummary(result.data);
                    break;
                case 2:
                    this.userStore.setAuditTrails(result.data);
                    // console.log("[Login][handleResult] this.userStore.auditTrails = ", this.userStore.auditTrails);
                    break;
                case 3:
                    this.userStore.setUsers(result.data);
                    break;
                case 4:
                    this.userStore.setProducts(result.data);
                    break;
                case 5:
                    this.userStore.setPractitioners(result.data);
                    break;
                case 6:
                    this.userStore.setLocations(result.data);
                    break;
                case 7:
                    this.userStore.setBillingPlans(result.data);
                    break;
                case 8:
                    this.userStore.setSuppliers(result.data);
                    break;
                case 9:
                    this.userStore.setClients(result.data);
                    break;
                default:
                    console.warn(`Unhandled result at index ${index}:`, result);
            }
        },
        loadDataInBackground() {
            // console.log("[Login][loadDataInBackground] Start of function.");

            const promises = [
                CompanyService.getCompanyConfiguration(this.userStore.user.companyId),
                DashboardService.getFinancialSummaryOverThreeMonthsForCompany(this.userStore.user.companyId),
                AuditTrailService.getCompanyAuditTrails(this.userStore.user.companyId),
                UserService.getCompanyUsers(this.userStore.user.companyId),
                ProductService.getCompanyProducts(this.userStore.user.companyId),
                PractitionerService.getCompanyPractitioners(this.userStore.user.companyId),
                LocationService.getCompanyLocations(this.userStore.user.companyId),
                BillingPlanService.getActiveBillingPlans(this.userStore.user.companyId),
                SupplierService.getCompanySuppliers(this.userStore.user.companyId),
                ClientService.getBasicCompanyClients(this.userStore.user.companyId)
            ];

            // Run the promises but do not await them.
            promises.forEach((promise, index) => {
                promise.then(result => {
                    // Handle the result here, e.g., assign to a data property
                    this.handleResult(index, result);
                }).catch(e => {
                    // Handle the error here
                    console.error("Error in promise", index, e);

                    if (e.response && e.response.status === 401) {
                        console.log("[Login][loadDataInBackground] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                });
            });
        },
        async handleLogin() {
            // console.log("[Login][handleLogin] Start of function. Redirecting to functionality.");

            this.submitted = true;

            try {
                var createData = {
                    username: this.userData.username,
                    password: this.userData.password,
                    activationCode: this.userData.activationCode,
                };

                // console.log("[Login][handleLogin] createData = ", createData);

                const responseData = await AuthenticationService.authenticateUser(createData);
                // console.log('[Login][handleLogin] Response = ', responseData);


                if (responseData.status === 202) {
                    console.log("[Login][handleLogin] responseData.status === 202.");

                    // TFA required – backend returned PendingTfaResponse
                    this.tfaRequired = true;
                    this.activeTab = 2;          // go to TFA code tab/screen
                    this.submitted = false;

                    // If you want to show the masked email the code was sent to
                    if (responseData.data && responseData.data.deliveryHint) {
                        this.maskedEmail = responseData.data.deliveryHint;
                        this.otpHint = responseData.data.otpHint;
                    }

                    return;
                }

                // If we get here, we expect HTTP 200 + JwtResponse → no TFA needed
                this.tfaRequired = false;

                this.userStore.setUserToken(responseData.data);
                this.userStore.setProductRights('SI');
                // console.log("[Login][handleLogin] this.userStore.accessToken = ", this.userStore.accessToken);
                // console.log("[Login][handleLogin] this.userStore.userId = ", this.userStore.userId);
                // console.log("[Login][handleLogin] this.userStore.companyId = ", this.userStore.companyId);
                // console.log("[Login][handleLogin] this.userStore.username = ", this.userStore.username);

                // const userData = await UserService.getUser(responseData.data.id);
                // console.log("[Login][handleLogin] userData = ", userData);

                const promises = [
                    UserService.getUser(responseData.data.id),
                    UserService.getUserConfig(responseData.data.id)
                ];

                const [userResult, userConfigResult] =
                    await Promise.allSettled(promises);

                if (userResult.status === "fulfilled") {
                    this.userStore.setUser(userResult.value.data);
                    // console.log("[Login][handleLogin] this.userStore.user = ", this.userStore.user);
                } else {
                    console.log("[Login][handleLogin] Error = ", userResult.reason);
                }

                if (userConfigResult.status === "fulfilled") {
                    this.userStore.setUserConfiguration(userConfigResult.value.data);
                    this.userConfiguration = userConfigResult.value.data;
                } else {
                    console.log("[Login][handleLogin] Error = ", userConfigResult.reason);
                }

                this.loadDataInBackground();

                if (this.userStore.user) {

                    if (this.userStore.user.roles.includes("ROLE_ISOWEB", 0)) {
                        console.log("[Login][handleLogin] Processing role for ROLE_ISOWEB");
                        console.log("[Login][handleLogin] this.userConfiguration.showWelcome = ", this.userConfiguration.showWelcome);

                        if (this.userStore.user.rights === 'R') {
                            this.$router.push("siAffiliate");
                        } else {
                            if (this.userConfiguration.showWelcome === 'Y') {
                                this.$router.push("siHelp");
                            } else {
                                this.$router.push("siHome");
                            }

                        }

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Login successful',
                            life: 3000
                        });

                    } else {
                        console.log("[Login][handleLogin] Processing no role");
                        this.$router.push("siLogin");

                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to login. Please try again.',
                            life: 3000
                        });
                    }
                }

            } catch (error) {
                console.error('[Login][handleLogin] Error:', error);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to login. Please try again.',
                    life: 3000
                });

                // 👇 Special handling for 429 from backend
                if (error.response && error.response.status === 429) {
                    console.log("[Login][handleLogin] Got 429 TOO_MANY_REQUESTS from backend.");

                    this.$toast.add({
                        severity: "error",
                        summary: "Please wait",
                        detail: "OTP already issued. Please try again in 1 minute.",
                        life: 4000,
                    });

                } else {
                    // Default error handling for other statuses (403, 500, etc.)
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Failed to login. Please try again.",
                        life: 3000,
                    });
                }

                this.activeTab = 1;
                this.userData = {};
                this.userData.username = '';
                this.userData.password = '';
                this.userData.activationCode = '';
                this.submitted = false;

                return;
            }

            this.activeTab = 1;
            this.userData = {};
            this.userData.username = '';
            this.userData.password = '';
            this.userData.activationCode = '';
            this.submitted = false;

        },
        async handleVerifyTfa() {
            console.log("[Login][handleVerifyTfa] Verifying TFA code.");

            this.submitted = true;

            try {
                const payload = {
                    username: this.userData.username,
                    code: this.userData.activationCode, // matches your backend DTO
                };

                console.log("[Login][handleVerifyTfa] payload = ", payload);
                console.log("[Login][handleVerifyTfa] this.userConfiguration = ", this.userConfiguration);

                const response = await AuthenticationService.verifyTfa(payload);
                console.log("[Login][handleVerifyTfa] Response = ", response);

                // On success, backend returns the same JwtResponse as /signin (no TFA)
                await this.finishLogin(response.data);

            } catch (error) {
                console.error("[Login][handleVerifyTfa] Error:", error);

                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Invalid or expired verification code. Please try again.",
                    life: 3000,
                });

                this.submitted = false;
            }
        },
        async finishLogin(jwtResponse) {
            // jwtResponse is response.data from backend JwtResponse
            this.userStore.setUserToken(jwtResponse);
            // console.log("[Login][finishLogin] accessToken = ", this.userStore.accessToken);
            // console.log("[Login][finishLogin] userId = ", this.userStore.userId);
            // console.log("[Login][finishLogin] companyId = ", this.userStore.companyId);
            // console.log("[Login][finishLogin] username = ", this.userStore.username);

            const promises = [
                UserService.getUser(jwtResponse.id),
                UserService.getUserConfig(jwtResponse.id),
            ];

            const [userResult, userConfigResult] = await Promise.allSettled(promises);

            if (userResult.status === "fulfilled") {
                this.userStore.setUser(userResult.value.data);
                console.log("[Login][finishLogin] user = ", this.userStore.user);
            } else {
                console.log("[Login][finishLogin] Error = ", userResult.reason);
            }

            if (userConfigResult.status === "fulfilled") {
                this.userStore.setUserConfiguration(userConfigResult.value.data);
                this.userConfiguration = userConfigResult.value.data;
            } else {
                console.log("[Login][finishLogin] Error = ", userConfigResult.reason);
            }

            this.loadDataInBackground();

            if (this.userStore.user) {
                if (this.userStore.user.roles.includes("ROLE_ISOWEB", 0)) {
                    console.log("[Login][finishLogin] Processing role for ROLE_ISOWEB");
                    console.log("[Login][finishLogin] this.userConfiguration.showWelcome = ", this.userConfiguration.showWelcome);

                    if (this.userStore.user.rights === 'R') {
                        this.$router.push("siAffiliate");
                    } else {
                        if (this.userConfiguration.showWelcome === 'Y') {
                            this.$router.push("siHelp");
                        } else {
                            this.$router.push("siHome");
                        }

                    }

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Login successful',
                        life: 3000
                    });

                } else {
                    console.log("[Login][finishLogin] Processing no role");
                    this.$router.push("siLogin");

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to login. Please try again.',
                        life: 3000
                    });
                }
            }

            // Reset UI state
            this.activeTab = 1;
            this.tfaRequired = false;
            this.userData = {
                username: "",
                password: "",
                activationCode: "",
            };
            this.submitted = false;
        },
        handleCancel() {
            this.activeTab = 1;
            console.log("[Login][handleCancel] Start of function. Redirecting to functionality.");
            this.$toast.add({
                severity: 'success',
                summary: 'Successful',
                detail: 'Reset Back to Login',
                life: 3000
            });
            // this.$router.push("login");
        },
        handleForgotPassword() {
            console.log("[Login][handleCancel] Start of function. Redirecting to functionality.");
            this.$toast.add({
                severity: 'success',
                summary: 'Successful',
                detail: 'Password Reset Initiated',
                life: 3000
            });
            this.$router.push("siForgotPassword");
        },
        handleRegister() {
            window.location.href = "https://www.simplyinvesting.com";
        },
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
